module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('BuyoutTabs'), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.buyout')))
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e40193b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/buyout/Country.vue
// module id = 584
// module chunks = 0